import { NgClass } from '@angular/common';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { AfTranslateDirective } from '@shared/modules/translate/directive/af-translate.directive';
import { CommonUtilsService } from '@shared/services/common-utils/common-utils.service';

@Component({
  selector: 'box-protection',
  templateUrl: './box-protection.component.html',
  standalone: true,
  imports: [
    AfTranslateDirective,
    NgClass
  ]
})
export class BoxProtectionComponent implements OnInit, OnDestroy{
  boxProtection:any = {
    id: this.commonUtilsService.createId(),
    icon: '',
    title: '',
    subTitle: ''
  }

  constructor(private commonUtilsService: CommonUtilsService){}

  @Input() data: any = null;
  @Input() type: any = null;

  ngOnInit(): void {
    window.addEventListener('resize', this.showMoreInfo);
    this.configureModalWindow();
  }

  configureModalWindow(){
    let boxProtection = this.boxProtection;
    switch(this.type){
      case 'additional':
        boxProtection.icon = 'lf-icon-information';
        boxProtection.title = 'channel-configuration.additional-info';
         boxProtection.subTitle = 'protection-data-modal.want-know';

        break;
      case 'protection':
        boxProtection.icon = 'lf-icon-shield';
        boxProtection.title = 'protection-data-modal.data-protection-information';
       boxProtection.subTitle = 'protection-data-modal.processing-personal-data';
        break;
      default:
        boxProtection.icon = 'lf-icon-legal-reference';
        boxProtection.title = 'channel-configuration.legal-info';
        boxProtection.subTitle = 'protection-data-modal.apply-regulations';
        break;
    }
  }

  showMoreInfo(){
    return this.commonUtilsService.showMoreInfo('box-protection-'+this.boxProtection.id);
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.showMoreInfo);
  }

}
